import FacebookEmbedCustom from "@components/Embeds/FacebookEmbedCustom";
import InstagramEmbedCustom from "@components/Embeds/InstagramEmbedCustom";
import TiktokEmbedCustom from "@components/Embeds/TiktokEmbedCustom";
import XEmbedCustom from "@components/Embeds/XEmbedCustom";
import { EmbedType } from "@pages/Article/components/ArticleParagraphElements/utils/enums";
import { cn } from "@util/helpers";
import { DOMNode, domToReact, Element } from "html-react-parser";
import IframeResizer from "iframe-resizer-react";

type TransformOptions = string | boolean | void | object | Element | null;

export const createEmbed = () => {
  const transform = (node: DOMNode, type: EmbedType): TransformOptions => {
    if (node.type !== "tag") return null;

    const element = node;

    if (element.name === "div" && type === EmbedType.Embed) {
      const children = element.children as DOMNode[];
      const transformWithType = (child: DOMNode) => transform(child, type);

      return (
        <div className="mb-6">
          {domToReact(children, { replace: transformWithType })}
        </div>
      );
    }

    if (element.name === "a" && type === EmbedType.X) {
      const el = node;
      const href = el.attribs.href;

      return <XEmbedCustom url={href} />;
    }

    if (element.name === "a" && type === EmbedType.Instagram) {
      const el = node;
      const href = el.attribs.href;

      return <InstagramEmbedCustom url={href} />;
    }

    if (element.name === "iframe" && type === EmbedType.Facebook) {
      const el = node;
      const href = el.attribs.src;
      const urlParams = new URLSearchParams(href.split("?")[1]);
      const fbUri = urlParams.get("href") || "";

      return <FacebookEmbedCustom url={fbUri} />;
    }

    if (element.name === "blockquote" && type === EmbedType.Tiktok) {
      const el = node;
      const href = el.attribs.cite;

      return <TiktokEmbedCustom url={href} />;
    }

    if (element.name === "iframe" && type === EmbedType.Embed) {
      const el = node;
      const { src, id, classname, className } = el.attribs;

      const extraClass = classname || className || ""; // Handle both 'classname' and 'className' attributes
      return (
        <IframeResizer
          data-testid={id}
          src={src}
          className={cn("w-full", extraClass)}
        />
      );
    }

    return null;
  };

  return transform;
};
